import React, { useEffect, useState } from "react";
import Page from "components/PageWrapper";
import { getEvents } from "api";

const EventItem = (props) => {
  const { name, link, location, dates, time, image } = props || {};
  return (
    <div className="row">
      <div className="image col-12 col-lg-3 pb-1">
        <img src={image} className="img-thumbnail" alt={name} />
      </div>
      <div className="col text-start pb-3">
        <div className="h6">{name}</div>
        <dl className="dl-horizontal">
          <dt>Location</dt>
          <dd>{location}</dd>
          <dt>Dates</dt>
          <dd>{dates}</dd>
          <dt>Time</dt>
          <dd>{time}</dd>
          <dt>Event Link</dt>
          <dd>
            {link ? (
              <a href={link} target="_blank" rel="noreferrer">
                <span className="title">Click Here</span>
              </a>
            ) : null}
          </dd>
        </dl>
      </div>
    </div>
  );
};

const EventsList = () => {
  const [data, setData] = useState(null);
  
  useEffect(() => {
    const response = getEvents();
    if (response) {
      setData(response);
    } 
  }, [])

  if (!data) return null;

  const sorted = data.sort((a, b) => b.id - a.id);
  return sorted.map((props, idx) => <EventItem key={idx} {...props} />);
};

export default function Events() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <Page>
      <section className="page-section">
        <div className="container text-center">
          <div className="h5">
            <span>Our</span>
            &nbsp;
            <span>Latest Events</span>
          </div>
          <div className="row py-3 gx-3">
            <div className="col-12">
              <EventsList />
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
